import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';

export interface IEmbloomQuestionnairesValidated {
    id: string;
    isDecisionSupport: boolean;
    isEmbloomGrading: boolean;
    isStandard: boolean;
}

export const embloomQuestionnairesSchema: ISchemaContainer<IEmbloomQuestionnairesValidated[]> = {
    schema: Koi.array()
        .items(
            Koi.object({
                id: Koi.string().uuid(),
                isDecisionSupport: Koi.boolean(),
                isEmbloomGrading: Koi.boolean(),
                isStandard: Koi.boolean(),
            })
        )
        .options({ convert: false, presence: 'required' }),
};
